document.addEventListener("DOMContentLoaded", function() {

    function removeBackgrounds() {
        document.querySelectorAll(".unavailable").forEach(el => {
            el.style.setProperty("background-image", "none", "important");
            el.style.setProperty("background-color", "#fff", "important");
        });
    }

    // Run once
    removeBackgrounds();

    // Watch for dynamically added elements
    const observer = new MutationObserver(() => {
        removeBackgrounds();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});